import { Router } from 'react-router-dom';
import React, { useRef, useState, useLayoutEffect } from 'react';
import { History } from 'history';

export type CustomBrowserRouterProps = {
  basename?: string,
  children?: React.ReactNode,
  browserHistory: History
}

export const CustomBrowserRouter = ({ basename, children, browserHistory }: CustomBrowserRouterProps) => {
  const historyRef = useRef(browserHistory);
  const history = historyRef.current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
};
